<ng-template #inputContent>
  @if (label) {
    <label>{{ label }}</label>
  }
  <div
    class="text-input-container {{ sizeClass }}"
    [class.invalid]="isInvalid"
    [class.outlined]="variant() === 'outlined'"
    [class.auto-width]="autoWidth"
    [class.disabled]="disabled"
    >
    <!-- Number fields render as text: native number inputs hide a trailing "." and the cursor from script.
    Their maxLength is enforced by the guards, so a paste is sanitized before it is length-limited. -->
    <input
      #inputElement
      [type]="type === 'number' ? 'text' : type"
      [attr.inputmode]="type === 'number' ? 'decimal' : null"
      [attr.aria-label]="ariaLabel"
      [placeholder]="placeholder"
      [ngModel]="value"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onInputChange($event)"
      [disabled]="disabled"
      [readOnly]="readOnly"
      [attr.maxlength]="type === 'number' ? null : maxLength"
      (blur)="onTouched()"
      (keydown)="preventInvalidNumberInput($event)"
      />

    @if(showRestField && value !== '' && value != null && !disabled){
      <div class="clear" matTooltip="Clear field">
        <button class="clear-btn" type="button" (click)="onRestField()">
          <mat-icon class="clear-icon">clear</mat-icon>
        </button>
      </div>
    }

    @if (icon()) {
      <div class="icon" [matTooltip]="icon()?.tooltip" (click)="iconClick.emit()">
        <mat-icon>{{ icon()?.name }}</mat-icon>
      </div>
    }

    @if (showCopyIcon) {
      <div class="copy-icon" [matTooltip]="tooltipText()" #tooltip="matTooltip" (click)="onCopyIconClick()">
        <!-- Show projected content if available, otherwise use default icon -->
        @if (hasIconContent) {
          <ng-content select="[icon]"></ng-content>
        } @else {
          <img src="shared-assets/icons/copy.svg" class="copy-icon" alt="Copy icon" />
        }
      </div>
    }
  </div>

  @if(helperLink()){
    <div class="helper-text-container">
      @if (!helperLinkPermission) {
        <ng-container *ngTemplateOutlet="helperLinkContent"></ng-container>
      } @else {
        <ng-container *appHasPermission="helperLinkPermission">
          <ng-container *ngTemplateOutlet="helperLinkContent"></ng-container>
        </ng-container>
      }
    </div>
  }

  @if (isInvalid && errorMessage) {
    <div class="error-message">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <span class="error-text"> {{ errorMessage }}</span>
    </div>
  }
</ng-template>

@if (!inputPermission) {
  <div class="text-input-wrapper">
    <ng-container *ngTemplateOutlet="inputContent"></ng-container>
  </div>
} @else {
  <div class="text-input-wrapper" *appHasPermission="inputPermission">
    <ng-container *ngTemplateOutlet="inputContent"></ng-container>
  </div>
}

<ng-template #helperLinkContent>
  <span class="helper-link" (click)="helperLinkClick.emit()">
    {{ helperLink() }}
  </span>
</ng-template>
